import MedicationsPage from "./MedicationsPage";

export default MedicationsPage;